import { defineMessages } from "react-intl";

const messages = defineMessages({
  nameLabel: {
    id: "savedLocations.namingCard.namingForm.name.label",
    defaultMessage: "Name this location",
    description: "Accessible label of the name field in the card shown after saving a location",
  },
  namePlaceholder: {
    id: "savedLocations.namingCard.namingForm.name.placeholder",
    defaultMessage: "Warehouse, Hotel, Lunch spot",
    description: "Placeholder of the name field in the card shown after saving a location",
  },
  saved: {
    id: "savedLocations.namingCard.namingForm.saved",
    defaultMessage: "<b>Saved as “{name}”.</b> Give it a name, or make it your Home or Work.",
    description: "Message of the card shown right after a location is saved",
  },
  saveName: {
    id: "savedLocations.namingCard.namingForm.saveName",
    defaultMessage: "Save name",
    description: "Button that saves the typed name, in the card shown after saving a location",
  },
  setHome: {
    id: "savedLocations.namingCard.namingForm.setHome",
    defaultMessage: "Set as Home",
    description: "Button that makes the location just saved the rep's Home",
  },
  setWork: {
    id: "savedLocations.namingCard.namingForm.setWork",
    defaultMessage: "Set as Work",
    description: "Button that makes the location just saved the rep's Work",
  },
  undo: {
    id: "savedLocations.namingCard.namingForm.undo",
    defaultMessage: "Undo",
    description: "Button that deletes the location just saved, in the card shown after saving it",
  },
});

export default messages;
